import type {
    AddCommerceCartLineRequest,
    AddCommerceCartLineResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const addCommerceCartLineOperation = defineCommerceOperation<
    AddCommerceCartLineRequest,
    AddCommerceCartLineResponse
>("commerce.cart.lines.add");
